export default __webpack_public_path__ + "static/media/rice_stir_fry.2d878c33.jpg";